import React from 'react'
import { Link } from 'react-router'
import get from 'lodash/get'
import { prefixLink } from 'gatsby-helpers'
import { rhythm } from 'utils/typography'
import Helmet from "react-helmet"
import { config } from 'config'
import Bio from 'components/Bio'
import Intro from 'components/Intro'
import FontIcon from 'material-ui/FontIcon';
import Divider from 'material-ui/Divider';
import { instanceOf } from 'prop-types';
import { CookiesProvider, withCookies, Cookies } from 'react-cookie';

import { selectSeries, setCookie } from './lib';

class BlogIndex extends React.Component {
  // constructor() {
  //   super();
  //   var self = this;
  //   self.state({
  //     locale: "",
  //     pagesBySeries: { pages: [], series: [] }
  //   })
  //   this.updateState = this.updateState.bind(this);
  // }
  // updateState(v) {
  //   this.setState({
  //     locale: v,
  //     pagesBySeries: selectSeries(this.props.route.pages, locale)
  //   })
  // }

  constructor(props) {
    super(props)
    this.updateState = this.updateState.bind(this)
  }

  componentDidMount() {
    const locale = setCookie();
    // console.log("did mount locale: ", locale)
    this.updateState(locale)
  }

  updateState(locale) {
    let pagesBySeries = selectSeries(this.props.route.pages, locale)
    this.setState({
      locale: locale,
      pagesBySeries: pagesBySeries
    })
  }

  setLocale(v) {
    if (this.state && this.state.locale !== v) {
      const cookie = new Cookies();
      cookie.set('locale', v)
      this.updateState(v)
    }
  }

  render() {

    // console.log("state: ", this.state);
    let pagesBySeries = { series: [], pages: [] };
    if (this.state && this.state.pagesBySeries) {
      pagesBySeries = this.state.pagesBySeries
    }

    return (
      <div>
        <Helmet
          title={config.blogTitle}
          meta={[
            { "name": "description", "content": "Sample blog" },
            { "name": "keywords", "content": "blog, articles" },
          ]}
        />

        <p>Lang: <a onClick={(node) => this.setLocale("en")}>EN</a> {' / '} <a onClick={(node) => this.setLocale("cn")}>CN</a></p>
        <Bio />

        <Intro />
        {pagesBySeries.series.map((k) => (
          <div key={k}>
            <Divider />
            <br />
            <br />
            <ul>
              {pagesBySeries.pages[k].map((page) => (
                <li
                  key={page.path}
                  style={{
                    marginBottom: rhythm(1 / 4),
                  }}
                >
                  <Link style={{ boxShadow: 'none' }} to={prefixLink(page.path)}>
                    {get(page, 'data.title', page.path)}
                  </Link>
                  <p style={{ fontSize: '15px' }}>
                    {page.data.series ? <span className="metadata">  <FontIcon style={{ fontSize: '14px' }} className="material-icons" >bookmark</FontIcon>   {" " + page.data.series + " series "} </span> : ""}
                    {page.data.tags ? <span className="metadata"><FontIcon style={{ fontSize: '14px' }} className="material-icons" >assignment</FontIcon> {" " + page.data.tags}</span> : ""}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        ))}

      </div>
    )
  }
}

BlogIndex.propTypes = {
  route: React.PropTypes.object,
}

export default BlogIndex;



// WEBPACK FOOTER //
// ./index.js